import { render, staticRenderFns } from "./create-category.vue?vue&type=template&id=fdb576e2"
import script from "./create-category.vue?vue&type=script&lang=js"
export * from "./create-category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports